import { render, staticRenderFns } from "./MigrationController.vue?vue&type=template&id=b35ba222&scoped=true&"
import script from "./MigrationController.vue?vue&type=script&lang=js&"
export * from "./MigrationController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35ba222",
  null
  
)

export default component.exports